<template>
    <div class="container-fluid" style="max-height: 100%; height: 100%; overflow: auto; padding-top: 120px; padding-bottom:120px;">
        <div class="row justify-content-center align-self-center">
            <div class="container-fluid mt-2">
                <div class="row d-flex align-items-center flex-column ">
                    <div class="col-xl-6 text-center">
                        
                        <h1>
                            Welcome Dear Artist
                        </h1>
                        <p>join</p>
    
    <p>
        <img src="img/brand/snap_logo_black.png" class="navbar-brand-img" alt="Sidebar logo" style="width:300px;">
    </p>
                    </div>
                    <br>
                    <div class="col-xl-6 text-center mt-2">
                        <a href="javascript:void(0);" class="btn btn-dark" @click="startWizard">Apply now</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import { mapGetters } from 'vuex'
      import { Tooltip } from 'element-ui'
      export default {
        name: 'wizard-header',
        props: {
            token: String,
        },
        computed: {
            ...mapGetters({
                currentSettings: 'currentSettings',
                currentSnapWizard: 'currentSnapWizard',
                currentSnapWizardStep: 'currentSnapWizardStep',
            }),
        },
        methods: {
            startWizard(){
                this.currentSnapWizard.formtype = "extended";
                this.$store.dispatch('snapWizardNextStep');
            },
            csss() {
                return `
                h1 {
                    color: #fff;
                    font-size: 25pt;
                }
                p {
                    color: #fff;
                    font-size: 14pt;
                }
                .artfair {
                    font-size: 25pt;
                    font-weight: bold;
                }
                .pinktext {
                    color: #e62054;
                }
                .card {
                background-color: #e62054 !important;
                box-shadow: none !important;
                -moz-box-shadow: none;
                -webkit-box-shadow: none !important;
                box-shadow: 0 0 0 transparent;
                border: 0 !important;
                border: transparent !important;
    
                }
                .card-footer {
                background-color: #e62054 !important;
                border: 0 !important;
                border: transparent !important;
                }
                body {
                background-color: #e62054;
                }`
            }
        },
        mounted(){
            this.$emit('allowProceed');
            //document.getElementById('customStyle').innerHTML = this.css();
        },
      };
    
    </script>
    